import { render, staticRenderFns } from "./EmailForm.vue?vue&type=template&id=7aa56a70&scoped=true"
import script from "./EmailForm.vue?vue&type=script&lang=js"
export * from "./EmailForm.vue?vue&type=script&lang=js"
import style0 from "./EmailForm.vue?vue&type=style&index=0&id=7aa56a70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa56a70",
  null
  
)

export default component.exports